import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from "rxjs";
import { AuthService } from "../_services/auth.service";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class UserTokenInterceptor implements HttpInterceptor {

    private refreshing: boolean = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject(null);


    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // req = req.clone({setHeaders: {'ngrok-skip-browser-warning': 'api'}});
        if (this.authService.currentUser && !this.authService.isRefreshingTokenUrl(req.url)) {
            const authHeader = this.getAuthHeader();
            const modReq = req.clone({ setHeaders: authHeader });

            return next.handle(modReq).pipe(
                catchError((err: HttpErrorResponse) => {
                    // Token expired
                    if (err.status === 401 && this.authService.currentUser && !this.refreshing) {
                        this.refreshing = true;
                        this.refreshTokenSubject.next(null);
                        // Refresh token
                        return this.authService.doRefreshToken(this.authService.currentUser.token.refresh_token).pipe(
                            switchMap((token) => {
                                let refreshedUser = this.authService.currentUser;
                                refreshedUser.token = token;
                                this.authService.saveCurrentUser(refreshedUser);
                                this.refreshing = false;
                                this.refreshTokenSubject.next(token);

                                const refreshReq = req.clone({
                                    setHeaders: this.getAuthHeader()
                                });
                                return next.handle(refreshReq);
                            }),
                            catchError((err) => {
                                this.refreshing = false;
                                this.authService.doLogout();
                                this.router.navigateByUrl('/login');
                                return throwError(() => new Error('Session expired. Please log in again.'));
                            })
                        );
                    } else if (this.refreshing) {
                        // Wait for token refreshing ends
                        return this.refreshTokenSubject.pipe(
                            filter((token) => token != null),
                            take(1),
                            switchMap((token) => next.handle(req.clone({
                                setHeaders: { Authorization: `${token.token_type} ${token.access_token}` }
                            })))
                        );
                    }

                    return throwError(() => err);
                })
            );
        }

        return next.handle(req);
    }

    private getAuthHeader(): { Authorization: string } {
        return {
            Authorization: `${this.authService.currentUser.token.token_type} ${this.authService.currentUser.token.access_token}`,
        };
    }
}